<template>
  <div class="main">
    <img class="not_banner"  :src="`${cdnresources}/prod/images/yueyangbao/success-01.png`" />
    <img class="not_banner1" :src="`${cdnresources}/prod/images/yueyangbao/success-02.png`" />
    <img class="not_banner2" :src="`${cdnresources}/prod/images/yueyangbao/success-03.png`" />
    <img class="wxCode" src="@/assets/img/pay/wxCode.jpg" alt="">
    <div class="btn-continue" @click="toJoin()">继续为家人参保</div>

<!--
    <div class="centent_img">
      <p class="text1">
        <span class="num">139</span>
        <span class="text">元保一年</span>
      </p>
      <div class="text2">
        最高400万医疗保障
      </div>
      <div class="flexbox">
        <div  class="flexlist">
          <img src="../../assets/img/pay/yes.png" alt="">
          政府指导可信赖
        </div>
        <div  class="flexlist">
          <img src="../../assets/img/pay/yes.png" alt="">
          参保人群无门槛
        </div>
        <div  class="flexlist">
          <img src="../../assets/img/pay/yes.png" alt="">
          医保内外全覆盖
        </div>
        <div  class="flexlist">
          <img src="../../assets/img/pay/yes.png" alt="">
          个账支付全家保
        </div>
      </div>
      <div class="tipdiv">
        <div class="tipbox">
          <div style="text-align: left;">
            <span class="tip1">官方指定参保平台</span>
            <span class="tip2">【巴陵e惠保】微信公众号</span>
          </div>
          <div class="imgbox">
            <img src="../../assets/img/pay/pai.png" alt="">
          </div>
        </div>
        <div class="codebox">
          <div class="imgbox">
            <img src="../../assets/img/pay/weChartCode.jpg" alt="">
          </div>
          <div class="textbox">
            <span class="span1">微信扫描二维码关注公众号</span>
            <span class="span2"> 查看我的保单</span>
          </div>
        </div>
      </div>
       <div style="margin: 16px;">
        <van-button round
                    block
                    @click="toJoin()"
                    type="info"
                    class="but"
                    native-type="submit">继续为家人投保</van-button>
      </div>
     
    </div>
-->
  </div>
</template>


<script>
import { getDeviceInfo } from '@/util/tools'
import { bdPromotion } from'@/api/pay'
import { cdnresources } from '@/util/config'
import { SetLeChengShare } from '@/util/set-wx-share'
import rrwebSDK from '@/util/rrweb.sdk-1.2.0'
export default {
  name: 'BuySuccess',
  components: {},
  filters: {},
  mixins: [],
  props: {},
  data() {
    return {
      rrwebsdk:null,
      cdnresources,
      payType: '',
      show: false,
      platInfo: getDeviceInfo()
    }
  },
  computed: {},
  watch: {
    $route: {
      handler: function (newVal, oldVal) {
        if (newVal.fullPath !== oldVal.fllPath) {
          this.initPage()
        }
      }
    }
  },
  created() {
    this.rrwebsdk = new rrwebSDK()
  // 开始录制
  this.rrwebsdk.restoreReport();
  },
  mounted() {
    this.payType = this.$route.query.payType
    if (this.payType === 'alipayAcc') { // 支付方式为支付宝时做埋点
      // eslint-disable-next-line no-undef
      __bl.api({ api: "成功投保", success: true, c1: "taSR_YL", time: 0 })
      // eslint-disable-next-line no-undef
      // __bl.api({api:"成功投保",success:true,c1:"taSR_YL"})
    }
    this.initPage()
        // 支付成功后调用百度营销(绿色字体为渠道码,跟随项目变动,切勿忘记更改)
    if (this.$route.query.fromSourceCode === 'market000001' || this.$route.query.fromSourceCode === 'market000002') {
      const bdPromotionUrl = sessionStorage.getItem('bdPromotion')
      console.log(bdPromotionUrl)
      let bdObj = {
        url: bdPromotionUrl,
        productCode: this.$route.query.baosicode,
        fromSourceCode: this.$route.query.fromSourceCode
      }
      bdPromotion(bdObj).then(res => {
        console.log(res)
      })
    }
    // 支付成功后调用头条埋点
    if (this.$route.query.fromSourceCode === 'market000004') {
      // 调用本地埋点服务
      const bdPromotionUrl = sessionStorage.getItem('bdPromotion')
      console.log(bdPromotionUrl)
      let bdObj = {
        url: bdPromotionUrl
      }
      bdPromotion(bdObj).then(res => {
        console.log(res)
      })
    }
  },
  destroyed() {
    sessionStorage.removeItem('buySuccess')
  },
  methods: {
    async initPage() {
      SetLeChengShare()
    },
    toJoin() {
      const { fromSourceCode, baosicode } = this.$route.query
      this.$router.push({
        path: '/area-insu-buy-detail',
        query: { fromSourceCode, baosicode }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.main{
  text-align: center;
  position: relative;
}
.wxCode{
  width: xvw(130);
  position: absolute;
  left: xvw(94);
  top: xvw(905);
}
.wxqrcode {
  margin-top: 8vh;
  display: flex;
  font-size: 3vw;
  img {
    width: 60%;
  }
  dd,
  p {
    margin: 0px;
  }
  dt img {
    width: 64.4%;
  }
}
.stateP {
  color: #000;
  font-size: 14px;
  line-height: 30px;
  text-align: left;
}
.not_banner {
  width: 100%;
}
.not_banner1 {
  width: 70%;
  margin-top: xvw(12);
}
.not_banner2 {
  width: 86%;
  margin-top: xvw(70);
}

.centent_img {
  text-align: center;
  padding: 0px 6vw;
  font-size: pxrem(28);
  line-height: pxrem(60);
  color: #000;
  .text1{
    .num{
    font-size: 50px;
    font-weight: bold;
    color: #EA332B;
    }
    .text{
      font-size: 22px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      line-height: 40px;
    }
  }
  .text2{
   font-size: 19px;
    font-weight: bold;
    color: #EA332B;
    line-height: 33px;
    background: #FFF1F1;
    width: 58%;
    margin: 0 auto;
  }
  .flexbox{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    .flexlist{
      margin-top: 8px;
      img{
        width:26px;
        vertical-align: sub;
      }
    }
  }
  .tipdiv{
    background: #FFF1F1;
    border-radius: 12px;
    padding: 12px;
    .tipbox{
      display: flex;
      justify-content: space-between;
      .tip1{
        font-size: 22px;
        color: #730D07;
        line-height: 30px;
        letter-spacing: 2px;
        font-weight: bold;
      }
      .tip2{
        font-size: 18px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #730D07;
        line-height: 50px;
        letter-spacing: 1px;
        display: inline-block;
      }
      .imgbox{
        width: 110px;
        img{
          width: 100%;
        }
      }
    }
    .codebox{
      display: flex;
      justify-content: space-between;
      background: #fff;
          padding: 10px;
      .imgbox{
        width:120px;
        img{
          width:100%;
        }
      }
      .textbox{
        text-align: left;
        .span1{
          font-size: 16px;
          font-weight: 700;
          color: #EA332B;
          line-height: 45px;
          letter-spacing: 1px;
        }
        .span2{
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          line-height: 40px;
          letter-spacing: 1px;
          display: inline-block;
        }
      }
    }

  }
  .but{
    height: px2rem(120);
    background: linear-gradient(to right, #FF7828 , #FF282C);;
    border-radius:  px2rem(60);
    border-color: #EDEEF2;
  }
  
}

.btn-continue {
  width: 80%;
  height: xvw(90);
  line-height: xvw(90);
  color:#fff;
  margin: xvw(28) auto;
  background:linear-gradient(180deg, #FE8066 0%, #D10003 100%);
  border-radius: 45px;
}
</style>
